export const PRODUCT_TYPE_SMA = 'Managed Accounts';
export const PRODUCT_TYPE_ETF = 'ETFs';
export const EMDASH = '—';
export const SINGLECLASS = 'SINGLCLASS';
export const NA = 'NA';
export const N_A = 'N/A';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
